export const AUthErrorMessages = {
  wrongPassword:
    'The current password is invalid or the user does not have a password.',
  wrongPasswordMessage:
    'The email or password is invalid. Please provide right credentials to login.',
  toomanyAttemptsMessage:
    'Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later',
  unkownServerError: 'Something went wrong.',
  userDoesntExist: 'Either Username or password provided is incorrect.'
};
